import { BaseStoriesClient, StoryType } from "@core/types";

class StoriesClient extends BaseStoriesClient {
  async getStories(): Promise<StoryType[]> {
    throw Error("getStories not implemented");
  }
}

export default StoriesClient;
